// extracted by mini-css-extract-plugin
export default {"text":"ActivateAccountWindow_text__jpXTm","btnsWrapper":"ActivateAccountWindow_btnsWrapper__REoPb","window":"ActivateAccountWindow_window__xmjaF"};